module.exports = __webpack_public_path__ + "static/media/globe-europe.dfe8ee3b.svg";